Namespace 'Customer.Views.Activity'

class Customer.Views.Activity.ContentTypeFilterView extends Backbone.View
  template: JST['backbone/templates/customer/activity/content_type_filter/content_type_filter']
  id: 'type_and_tags_filter'
  className: 'performance-filter activity-filter-box'

  initialize: (subtypes, @selectedSubtypes = [], @metricsSelectorContainer) ->
    @subtypes = @_parseSubtypes(subtypes)
    @groupNames = ['facebook', 'twitter', 'instagram', 'other']

  render: ->
    @$el.html(@template)
    @groupNames.map (groupName) => @_renderGroup(groupName)
    @$el.find('#type-filter-headers input').change((event) =>
      checkbox = event.target
      @$el.find("#type-filter-childs ##{checkbox.value} input").prop('checked', checkbox.checked)
      @metricsSelectorContainer?.resetSelectableColumns()
    )
    @_selectAll() if @selectedSubtypes.length == 0
    @

  _renderGroup: (groupName) ->
    return @_renderSingleElement(groupName) if @subtypes[groupName]?.length == 1
    @_renderHeader groupName
    @_renderChildren groupName

  _renderSingleElement: (groupName) ->
    subtype = @subtypes[groupName][0]
    columnView = new Customer.Views.Activity.SingleElementColumnView
      subtype: subtype
      isSelected: @selectedSubtypes.includes subtype
    @$('#type-filter-headers').append columnView.render().el
    subtypeChildrenView = new Customer.Views.Activity.SubtypeChildrenView
      subtypes: []
      id: groupName
      selectedSubtypes: []
    @$('#type-filter-childs').append subtypeChildrenView.render().el

  _renderChildren: (name) ->
    return unless @subtypes[name]

    subtypeChildrenView = new Customer.Views.Activity.SubtypeChildrenView({
      subtypes: @subtypes[name],
      id: name,
      selectedSubtypes: @selectedSubtypes
    })
    @listenTo(subtypeChildrenView, 'subtype:checkbox:change', => @metricsSelectorContainer?.resetSelectableColumns())
    @$el.find('#type-filter-childs').append(subtypeChildrenView.render().el)

  _renderHeader: (headerName) ->
    return unless @subtypes[headerName]
    isSelected = @subtypes[headerName].every((subtype) => @selectedSubtypes.includes(subtype))
    headerView = new Customer.Views.Activity.HeaderView(headerName, isSelected)
    @$el.find('#type-filter-headers').append(headerView.render().el)

  _parseSubtypes: (subtypes) ->
    parsedSubtypes = {}
    subtypes.forEach((subtype) =>
      if @_types().facebook.includes(subtype)
        parsedSubtypes = @_appendSubtype(parsedSubtypes, subtype, 'facebook')
      if @_types().twitter.includes(subtype)
        parsedSubtypes = @_appendSubtype(parsedSubtypes, subtype, 'twitter')
      if @_types().instagram.includes(subtype)
        parsedSubtypes = @_appendSubtype(parsedSubtypes, subtype, 'instagram')
      if @_types().other.includes(subtype)
        parsedSubtypes = @_appendSubtype(parsedSubtypes, subtype, 'other')
    )
    parsedSubtypes

  _appendSubtype: (parsedSubtypes, subtype, group) ->
    parsedSubtypes[group] = (parsedSubtypes[group] || [])
    parsedSubtypes[group].push(subtype)
    parsedSubtypes

  _types: ->
    {
      facebook: [
        'fb-post',
        'fb-comment',
        'fb-message',
        'fb-user'
      ],
      twitter: [
        'tweet',
        'direct-message',
        'retweet',
        'quote',
        'tw-user'
      ],
      instagram: [
        'ig-image',
        'ig-video',
        'ig-comment',
        'ig-message',
        'ig-user'
      ],
      other: [
        'email',
        'email-user',
        'yt-comment'
        'yt-user',
        'webchat',
        'gp_review_comment',
        'apple_app_store_review_comment',
        'whatsapp_message-user',
        'li-user',
        'google-my-business-review',
        'tiktok-comment',
        'tiktok-user'
      ]
    }

  _selectAll: ->
    @$el.find('input').prop('checked', true)
